/* eslint-disable object-curly-newline */
import {
  storeActionCommit,
} from '@/utils/common-utils';

export default {
  incrementPendingRequestCount({ commit }) {
    return storeActionCommit(commit, 'incrementPendingRequestCount')();
  },

  decrementPendingRequestCount({ commit }) {
    return storeActionCommit(commit, 'decrementPendingRequestCount')();
  },

  initStore() {
    const xCart = localStorage.getItem('x-cart');
    const accessToken = localStorage.getItem('access-token');
    if (xCart != null && accessToken != null) {
      this.dispatch('shoppingCart/fetchShoppingCart', {
        id: xCart,
      });
    }

    this.dispatch('user/createTempUser');
    // Runs from the root `beforeCreate`, i.e. before navbar.vue's `mounted()`
    // installs the 'QC' default, so the raw value can still be null here. The
    // writers (add-to-cart.vue, product.vue) normalize to 'QC'|'ON', so reading
    // the raw value would look up `cartProductsnull` and miss the real cart.
    const countryCode = localStorage.getItem('countryCode') === 'ON' ? 'ON' : 'QC';
    let storedCart = null;
    try {
      storedCart = JSON.parse(localStorage.getItem("cartProducts" + countryCode));
    } catch (e) {
      storedCart = null;
    }
    // Only seed the store when there is something to seed. Dispatching a null
    // payload used to write the string "null" back into the key on every boot,
    // which permanently broke the readers that call `.length` on it.
    if (Array.isArray(storedCart) && storedCart.length) {
      this.dispatch('shoppingCart/updateLocalCartProducts', storedCart);
    }
  },  

};
